<div class="repeated-voucher-modal">
  <div class="icon-wrapper">
    <i class="fas fa-receipt"></i>
  </div>

  <h5 class="modal-heading">Comprobante repetido detectado</h5>

  <p class="modal-message">{{ message }}</p>

  <div class="actions">
    <button
      type="button"
      class="btn btn-danger action-btn"
      (click)="rejectRequest()"
    >
      Rechazar solicitud
    </button>

    <button
      type="button"
      class="btn btn-success action-btn"
      (click)="continueProcess()"
    >
      Seguir con el proceso
    </button>

    <button
      type="button"
      class="btn btn-outline-secondary action-btn"
      (click)="cancel()"
    >
      Cancelar
    </button>
  </div>
</div>
